import { render, staticRenderFns } from "./ProfileImage.vue?vue&type=template&id=7106de8a&"
import script from "./ProfileImage.vue?vue&type=script&lang=ts&"
export * from "./ProfileImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports